import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getCachedUser from '../services/user/getCachedUser';
import getUserAttributes from '../services/user/getUserAttributes';

// THUNKS
export const dehydrateUser = createAsyncThunk('user/dehydrateUser', getCachedUser.handler);
export const fetchUser = createAsyncThunk('user/fetchUser', getUserAttributes.handler);

const user_initial_state = {
  initialized: false,
  user_id: null,
  name: null,
  email: null,
  picture: null,
  phone_number: null,
  last_synced: null,
};

// slice definition
const slice = createSlice({
  name: 'user',
  initialState: user_initial_state,
  reducers: {},
  extraReducers: builder => {
    builder

      // dehydrateUser
      .addCase(dehydrateUser.pending, getCachedUser.pending)
      .addCase(dehydrateUser.fulfilled, getCachedUser.fulfilled)
      .addCase(dehydrateUser.rejected, getCachedUser.rejected)

      // fetchUser
      .addCase(fetchUser.pending, getUserAttributes.pending)
      .addCase(fetchUser.fulfilled, getUserAttributes.fulfilled)
      .addCase(fetchUser.rejected, getUserAttributes.rejected)
  },
});

// export const { mutateUserProfile } = slice.actions;
const { reducer } = slice;
export default reducer;